import { createFileRoute } from '@tanstack/react-router'
import { SectionHeader, useSiteScope } from '../../-section'
import { ProspectTable } from '../-parts'

export const Route = createFileRoute('/_app/$org/$host/outreach/_list/active')({
  component: ActivePage,
})

/** Every thread written to and not over, whoever's move it is. */
function ActivePage() {
  const { org, host, site } = useSiteScope()
  return (
    <>
      <SectionHeader title="Active" />
      <ProspectTable
        site={site}
        org={org}
        host={host}
        view="active"
        empty={{ title: 'Nothing active', description: `No thread is open for ${host}.` }}
      />
    </>
  )
}
